<template>
  <article class="relative">
    <div
      v-for="({ code, trip }, index) in docs"
      :key="code"
      class="flex items-center justify-center rounded-full shadow-lg font-bold bg-bgr border border-brd transition-all duration-75 first:hover:bg-thm-hover first:hover:text-thm-contrast first:hover:border-0"
      :class="[
        index ? 'absolute' : 'relative',
        trip?.price ? 'h-7 w-16' : 'h-11 w-11',
        {
          'first:border-0 first:bg-thm first:text-thm-contrast': selected,
          'first:border-0 first:text-thm': visited,
        },
      ]"
      :style="{
        top: `${index / 4}rem`,
        left: `${index / 4}rem`,
        zIndex: docs.length - index,
      }"
    >
      <span v-if="trip?.price">{{ toMoney(trip.price) }}</span>
      <WebccIcon v-else name="site/house" class="h-6 w-6" />
    </div>
  </article>
</template>

<script setup lang="ts">
import { clamp } from 'lodash-es'

const DOCS_DISPLAY_MAX = 3

const props = defineProps<{
  item: MapItemAccom
  selected?: boolean
  visited?: boolean
}>()

const confData = useConfdata()
const { toMoney } = useMoneyFormat(() => confData.currency)

const count = computed(() => clamp(props.item.count, 1, DOCS_DISPLAY_MAX))
const docs = computed(() => props.item.docs?.slice(0, count.value) ?? [])
</script>
